export default {
  title_developers: 'Все застройщики',
  breadcrumbs: {
    home: 'Главная',
    developers: 'Застройщики'
  },
  logo_alt: 'Логотип застройщика',
  banner_alt: 'Баннер застройщика',
  gallery_image_alt: 'Фото галереи',
  founded: 'Основан',
  residential_complexes: 'ЖК',
  buildings: 'Домов',
  properties: 'Квартир',
  no_available: 'Нет доступных застройщиков',
  gallery: 'Фотогалерея',
  video: 'Видео',
  contacts: 'Контакты',
  residential_complexes_from: 'Жилые комплексы от {name}',
  properties_from: 'Объекты недвижимости от {name}',
  tabs: {
    base: 'Основное',
    media: 'Медиа'
  },
  fields: {
    name: 'Название',
    founded_year: 'Год основания',
    website: 'Сайт',
    email: 'Email',
    phone: 'Телефон',
    country: 'Страна',
    description_html: 'Описание (HTML)',
    project_types: 'Типы проектов',
    locations: 'Локации'
  },
  buttons: {
    more: 'Подробнее',
    pagination: {
      prev: 'Вперед',
      next: 'Назад'
    }
  }
}
